import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { formInputTheme } from "../../textinput/styled/formInputTheme";
import { checkboxLabelTheme } from "../checkboxTheme";

export interface LabelTextProps {
    isDisabled: boolean;
    themeMode: RequiredThemeKeys;
}

const getLabelColor = ({ isDisabled, themeMode }: LabelTextProps) => {
    return isDisabled ? checkboxLabelTheme.color.disabled(themeMode) : checkboxLabelTheme.color.rest(themeMode);
};

export const LabelText = styled("span")<LabelTextProps>`
    // We want the first line of text to line up with the checkbox so we cannot use flex to center.
    // In a multi-line label, the checkbox would be centered in the middle line of text, rather than
    // the first.
    margin-top: 1px;
    margin-left: ${({ themeMode }) => checkboxLabelTheme.gap(themeMode)};
    color: ${getLabelColor};
    font-weight: ${({ themeMode }) => checkboxLabelTheme.fontWeight(themeMode)};
    font-size: ${({ themeMode }) => formInputTheme.fontSize.box(themeMode)};
`;
